






















































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import EventsCalendarView from "./EventsCalendarView.vue";
import EventsBookingDetails from "./EventsBookingDetails.vue";
import EventsEventDetails from "./EventsEventDetails.vue";

import SettingsJson from "../../shared/SettingsJson";
import EventBookingJson, { getEventBookingTotalPrice } from "../../shared/EventBookingJson";
import { EventWithBookingsJson } from "../../shared/EventJson";
import { EventWithBookingJson } from "../../shared/EventJson";
import { EventBookingStatus, EventBookingStatusNames } from "../../shared/EventBookingStatus";

export default Vue.extend({
  name: "EventsCalendar",
  components: {
    Loading,
    EventsCalendarView,
    EventsBookingDetails,
    EventsEventDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    appFrameClickedButton: Object,
    BirthdayBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      loading: false,
      showBookingDetails: false,
      showEventDetails: false,
      selectedEventId: null as number | null,
      selectedEventBookingId: null as number | null,
      detailsMode: "read",
      reloadCalendar: new Date() as Date,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
  },
  methods: {
    /*** START: details view ***/
    toggleBookingDetails() {
      this.showBookingDetails = !this.showBookingDetails;

      if (this.showBookingDetails == false) {
        this.reloadCalendar = new Date();
      }
    },

    toggleEventDetails() {
      this.showEventDetails = !this.showEventDetails;

      if (this.showEventDetails == false) {
        this.reloadCalendar = new Date();
      }
    },

    openDetails(eventId: number | null, bookingId: number | null) {
      this.selectedEventId = eventId;
      this.selectedEventBookingId = bookingId;

      this.detailsMode = "read";

      if (eventId && bookingId) {
        this.toggleBookingDetails();
      } else if (eventId && bookingId == null) {
        this.toggleEventDetails();
      }
    },
    /*** END: details view ***/

    // print
    printCalendar() {
      var toPrint = document.getElementById("toPrint");

      if (toPrint != null) {
        var eles = this.$el.querySelectorAll(".print-view");

        for (let i = 0; i < eles.length; i++) {
          toPrint.appendChild(eles[i].cloneNode(true));
        }
      }

      this.$nextTick(() => {
        window.print();
      });

      this.$nextTick(() => {
        while (toPrint?.lastElementChild) {
          toPrint.removeChild(toPrint.lastElementChild);
        }
      });
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        //this.reloadSelectedBirthdays();
      }
    },
  },
  computed: {},
});
